export const ERROR_MESSAGE_PARAM = "error_message";
export const SUCCESS_MESSAGE_PARAM = "success_message";
